import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ChipsLabel, User } from '../../models/ui2-user-search.model';

@Component({
  selector: 'ui2-user-search-chip',
  templateUrl: './ui2-user-search-chip.component.html',
  styleUrls: ['./ui2-user-search-chip.component.scss']
})
export class Ui2UserSearchChipComponent {
  /**
   * Holds user information
   */
  @Input()
  public user: User;

  /**
   * Show/Hide close icon
   */
  @Input()
  public hideCloseIcon: boolean = false;

  /**
   * Show/Hide email address
   */
  @Input()
  public hideEmail: boolean = false;

  /**
   * Label that need to be show in the chips along with its BG color and color
   */
  @Input()
  public chipsLabel: ChipsLabel;

  /**
   * Flag if set to true will make the chip in disabled state
   */
  @Input()
  public isDisabled: boolean;

  /**
   *  When the close icon of the chip related to a user is clicked, the user object will be emitted
   */
  @Output()
  public closeClicked: EventEmitter<User> = new EventEmitter<User>();

  // Defaults Colors
  public readonly DEFAULT_LABEL_BG_COLOR: string = '#8A9BAB';
  public readonly DEFAULT_LABEL_COLOR: string = '#ffffff';

  /**
   * Called when close icon is clicked
   *
   * @param user
   */
  public onCloseClicked(user: User): void {
    this.closeClicked.emit(user);
  }
}
